import CustomerVehicleContainer from './CustomerVehicleContainer';

export default CustomerVehicleContainer;



// WEBPACK FOOTER //
// ./src/components/atoms/CustomerVehicle/index.js